import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "../lib/constants";

export default function ParallaxBanner({
  title = "Conectando cada hogar dominicano con su gente en Nueva York",
  overline = "NY → República Dominicana",
  testId = "parallax-banner",
}) {
  return (
    <section
      data-testid={testId}
      className="relative h-[420px] flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1613690399151-65ea69478674?auto=format&fit=crop&w=1920&q=80')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="absolute inset-0 bg-[#0B1F4D]/72" />
      <div className="relative z-10 text-center px-4 max-w-3xl">
        <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#D61F26] mb-3">
          {overline}
        </div>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white leading-tight">
          {title}
        </h2>
        <a
          href={buildWhatsAppLink("Hola, quiero información sobre envíos.")}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-8 inline-flex items-center gap-2 bg-[#D61F26] text-white px-7 py-4 uppercase font-bold tracking-wider hover:bg-[#A3161C] transition-all text-sm"
        >
          <MessageCircle className="w-4 h-4" strokeWidth={2.5} />
          Habla por WhatsApp
        </a>
      </div>
    </section>
  );
}
